<template lang="html">

    <div>

        <section class="ficha -empresa">

            <template v-if="!!data">

                <h2 class="ficha-title" :style="styles.colorBasic">{{(brand.nombreTitulaciones) ?
                    brand.nombreTitulaciones[lang] : $t('titulaciones')}}</h2>



                <article class="group" v-for="(n,key) in data">




                    <h3 class="group-title" :style="styles.colorBasic">{{n.titulacion}}</h3>

                    <div class="contenedor-data -grow" v-if="!!n.tutorPropuesto">
                        <h4 class="data-title" :style="styles.colorBasic">{{$t('tutor_propuesto')}}</h4>
                        <p>{{n.tutorPropuesto}}</p>
                    </div>

                    <div class="contenedor-botones row-center" v-if="n.necesitaTutorPropuesto || n.aprobada === null">
                        <div class="contenedor">
                            <a class="btn -xs" :style="styles.solidPrimary"
                                @click="sendValidar(n.idEstudiosOferta)">{{$t('aprobar')}}</a>
                            <a class="btn -xs" :style="styles.skull_primary"
                                @click="sendRechazar(n.idEstudiosOferta)">{{$t('denegar')}}</a>
                        </div>
                    </div>

                    <div class="contenedor-data" v-else>
                        <h4 class="data-title" :style="styles.colorBasic">{{$t('estado')}}</h4>
                        <p v-if="n.aprobada">{{$t('aprobada')}}</p>
                        <p v-if="n.aprobada == false">{{$t('denegada')}}</p>
                        <p v-if="n.aprobada == null">{{$t('pendiente_aprobacion')}}</p>
                    </div>

                </article>



            </template>

        </section>

        <div class="contenedor-popup column-center" v-if="!!popup.action">

            <div class="popup column-center" :style="styles.backgroundWhite">

                <p v-if="popup.action == 'validar'">{{$t('indique_tutor')}}</p>

                <p v-if="popup.action == 'rechazar'">{{$t('indique_motivo_rechazo')}}</p>

                <div class="contenedor-input">

                    <template v-if="data.filter(e => e.idEstudiosOferta == popup.idoferta)[0].necesitaTutorPropuesto">
                        <label for="" v-if="popup.action == 'validar'">{{$t('tutor_propuesto')}}</label>
                    </template>
                    
                    <label for="" v-if="popup.action == 'rechazar'">{{$t('motivo_denegacion')}}</label>
                    <input v-if="popup.action == 'rechazar'" v-model="infoproceso" type="text"
                        :style="styles.input_black">

                    <template v-if="data.filter(e => e.idEstudiosOferta == popup.idoferta)[0].necesitaTutorPropuesto">

                        <select v-if="popup.action == 'validar'" v-model="infoproceso" :style="styles.input_black">
                            <option value="">{{$t('selecciona_tutor')}}</option>
                            <option :value="n.idTutor" v-for="n in popup.tutores">{{n.nombreCompleo}}</option>
                        </select>
                    </template>
                </div>

                <div class="contenedor-input">
                    <label for="">{{$t('ficha.observaciones')}}</label>
                    <textarea name="observaciones" v-model="observaciones" :style="styles.input_black"></textarea>
                </div>

                <div class="botones row-around">
                    <a class="btn -xs" :loading="popup.loading" :style="styles.solidPrimary"
                        @click="sendEvaluada">{{$t('continuar')}}</a>
                    <a class="btn -xs" :style="styles.skull_primary" @click="cerrarPopup">{{$t('cancelar')}}</a>
                </div>

            </div>

        </div>

    </div>

</template>

<script lang="js">

    import { mapGetters, mapActions } from 'vuex';

    import onlyArrow from '@/components/parts/icons/only-arrow';
    import arrowlink from '@/components/parts/icons/arrow-link';

    export default {
        name: 'ficha-titulaciones',
        props: ['data', 'idOFerta'],
        data() {
            return {
                popup: {
                    action: '',
                    idoferta: '',
                    loading: false,
                    tutores: []
                },
                infoproceso: '',
                observaciones: ''
            }
        },
        computed: {
            ...mapGetters({
                styles: 'getStyles',
                brand: 'getBrand',
                lang: 'getLanguage'
            })
        },
        components: {
            'only-arrow': onlyArrow,
            'arrow-link': arrowlink,
        },
        methods: {
            ...mapActions(['cambiarEstadoAprobacion', 'requestTutoresParaEstudio']),
            sendValidar: function (id) {
                this.popup.action = 'validar';
                this.popup.idoferta = id;
                this.requestTutores();
            },
            sendRechazar: function (id) {
                this.popup.action = 'rechazar';
                this.popup.idoferta = id;
            },
            sendEvaluada: function () {

                let data = {
                    "idEstudiosOferta": this.popup.idoferta,
                    "idTutorPropuesto": this.infoproceso,
                    "motivoRechazo": this.infoproceso,
                    "aprobada": (this.popup.action == 'validar'),
                    'observaciones': this.observaciones
                }

                this.popup.loading = true;

                this.cambiarEstadoAprobacion(data).then(r => {
                    this.popup.loading = false;
                    if (r) {
                        this.cerrarPopup();
                        this.$emit('requestFicha');
                    } else {
                        this.cerrarPopup();
                    }
                });
            },
            cerrarPopup() {
                this.popup.action = '';
                this.popup.idoferta = '';
            },
            requestTutores() {
                this.requestTutoresParaEstudio(this.popup.idoferta).then(r => {
                    this.popup.tutores = r;
                });
            }
        }

    }
</script>

<style scoped lang="scss">
    .contenedor-popup {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 100;
        padding: 20px;

        .popup {
            width: 100%;
            max-width: 600px;
            padding: 40px;

            p {
                text-align: left;
            }

            .botones {
                margin-top: 30px;
                max-width: 250px;
                width: 100%;
            }

            .contenedor-input {
                margin-top: 20px;
            }

        }

    }
</style>


// WEBPACK FOOTER //
// src/components/views/aprobaciones/ficha-titulaciones.vue